import m from "../../geodata/es2015/curacaoHigh";
window.am4geodata_curacaoHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/curacaoHigh.js
// module id = null
// module chunks = 